import { AnalyticsService } from '../analytics/analytics.service';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService, User } from '../user/auth.service';
import { FormControl } from '@angular/forms';
import { UnsplashImageService } from '../unsplash/unsplash.service';
import { Urls } from '../unsplash/unsplash.response';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Result } from '../unsplash/unsplash.response';
import { RegistryService } from '../registry/registry.service';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Registry } from '../registry/registry';
import { Gift } from '../gift/gift';
import { PaymentService } from '../payment/payment.service';
import { Contribution } from '../track/contribution';
import { TranslatorService } from '../translator/translator.service';

@Component({
  selector: 'app-welcome-popup',
  templateUrl: './contribution-success-popup.component.html',
  styleUrls: ['./contribution-success-popup.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})


export class ContributionSuccessPopupComponent implements OnInit {
  @ViewChild('serachQuery') firstNameElement: ElementRef;
  hide: boolean;
  bankTitleField1: string;
  bankTitleField2: string;
  bankTitleField3: string;
  bankTitleField4: string;

  bank2TitleField1: string;
  bank2TitleField2: string;
  bank2TitleField3: string;
  bank2TitleField4: string;
  coupleNames: string;
  bank3TitleField1: string;
  bank3TitleField2: string;
  bank3TitleField3: string;
  bank3TitleField4: string;

  cancelReasonOtherText: string;
  manualPaymentProcessing = false;
  showCancelMode = false;
  tokenVerifiying = false;
  usernameCopyText = "Copy";
  noteCopyText = "Copy";
  contirbution: Contribution;
  cancelProcessing = false;
  manualSuccess = false;
  guestFirstName: string;
  currency: string;
  registry: Registry;
  selectionMade = false;
  hasContrib = false;
  cancelCompleted = false;
  contributionToken = null;
  showTranslation = false;

  fee = 0;
  isManualContribution = false;
  manualTransferMode: string;
  payment = 0; total = 0;
  @Input() showPopup = false;
  cancelReason: string;
  processing: boolean;
  isLoggedIn: any;
  bank1Label: string;
  bank2Label: string;
  bank3Label: string;
  showTimeline: boolean;


  constructor(private _unsplashImageService: UnsplashImageService,
    private _registryService: RegistryService,
    private _paymentService: PaymentService,
    private router: Router,
    private route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService,
    private _analyticsService: AnalyticsService,
    private _translatorService: TranslatorService

  ) {

    this.router.events.subscribe((event) => {

      if ((this.router.url.indexOf('/contribution-success') > -1)) {

        if (!this.registry) {
          this.registry = this._registryFirebaseService.registry;
          this.currency = this.registry.currency;
          this.coupleNames = this.registry.firstName + " & " + this.registry.partnerFirstName
        }

        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'hidden';
        const contribString = localStorage.getItem('contrib');

        const urlParams = new URLSearchParams(window.location.search);
        this.contributionToken = null;
        this.contributionToken = urlParams.get('contributionToken');


        if (contribString) {
          const contrib = JSON.parse(contribString);
          this.initPopupData(contrib);
          this.showPopup = true;
        } else if (!this.contributionToken && !contribString) {
          location.href = location.href.replace('/contribution-success', '');
        }

      } else {
        this.selectionMade = false;
        this.showPopup = false;

      }

    });

  }



  private initPopupData(contrib: any) {

    this.hasContrib = true;
    this.contirbution = contrib;
    if (localStorage.getItem('showTranslation')) {
      this.showTranslation = true;
    } else {
      this.showTranslation = false;
    }
    if (!this.contirbution.isManualContribution) {
      this.manualSuccess = true;
    }


    this.fee = contrib.fee;
    this.manualTransferMode = contrib.manualTransferPaymentMethod;
    this.isManualContribution = contrib.isManualContribution;
    this.payment = contrib.payment;

    if (this.isManualContribution) {
      this.total = this.payment
    } else {
      this.total = contrib.total;
    }
    this.guestFirstName = contrib.guestFirstName;
    if (!this.manualTransferMode) {
      this.manualTransferMode = 'stripe';
    }

    if (this.manualTransferMode.toLowerCase() === 'bank transfer') {
      this.manualTransferMode = 'bank';
    } else if (this.manualTransferMode.toLowerCase() === 'email/phone') {
      this.manualTransferMode = 'payId';
    } else if (this.manualTransferMode.toLowerCase().startsWith('cashon')) {
      this.manualTransferMode = 'cashOnTheDay';
    }
    else if (this.manualTransferMode.toLowerCase().startsWith('cheque')) {
      this.manualTransferMode = 'chequeOnTheDay';
    }
    else if (this.manualTransferMode.toLowerCase().startsWith('custom')) {
      this.manualTransferMode = 'customInstructions';
    }


    this.setPaymentMethodTitles();
  }
  openSendCards() {
    this.contirbution.id;
    const newPath = `/${this.registry.registryName.toLocaleLowerCase()}/wellwishes/${this.contirbution.id}`;
    window.location.href = `${window.location.origin}${newPath}`;
  }

  setPaymentMethodTitles() {
    //

    this.bankTitleField1 = null;
    this.bankTitleField2 = null;
    this.bankTitleField3 = null;
    this.bankTitleField4 = null;
    let bank1Country = this.registry.bankCountry ? this.registry.bankCountry : this.registry.country;
    const titles = this._registryService.getBankFieldTitles(bank1Country);
    this.bankTitleField1 = titles.field1;
    this.bankTitleField2 = titles.field2;
    this.bankTitleField3 = titles.field3;
    this.bankTitleField4 = titles.field4;

    if (this.registry.bank2Country) {
      this.bank2TitleField1 = null;
      this.bank2TitleField2 = null;
      this.bank2TitleField3 = null;
      this.bank2TitleField4 = null;
      const titles2 = this._registryService.getBankFieldTitles(this.registry.bank2Country);
      this.bank2TitleField1 = titles2.field1;
      this.bank2TitleField2 = titles2.field2;
      this.bank2TitleField3 = titles2.field3;
      this.bank2TitleField4 = titles2.field4;
    }

    if (this.registry.bank3Country) {
      this.bank3TitleField1 = null;
      this.bank3TitleField2 = null;
      this.bank3TitleField3 = null;
      this.bank3TitleField4 = null;
      const titles3 = this._registryService.getBankFieldTitles(this.registry.bank3Country);
      this.bank3TitleField1 = titles3.field1;
      this.bank3TitleField2 = titles3.field2;
      this.bank3TitleField3 = titles3.field3;
      this.bank3TitleField4 = titles3.field4;
    }
    if (this.registry.bankField1) {
      this.bank1Label = this._translatorService.getCountryAdjective(this.registry.bankCountry ? this.registry.bankCountry : this.registry.country) + " Bank Transfer";

    }
    if (this.registry.bank2Field1) {
      this.bank2Label = this._translatorService.getCountryAdjective(this.registry.bank2Country) + " Bank Transfer";


    }
    if (this.registry.bank3Field1) {
      this.bank3Label = this._translatorService.getCountryAdjective(this.registry.bank3Country) + " Bank Transfer";

    }

  }

  handleKeyboardEvents(event: any) {
    if (this.showPopup && event.keyCode === 27) {

      this.close();
    }



  }

  copyNote(text: string) {
    this.noteCopyText = "Copied";
    window.navigator['clipboard'].writeText(text);
  }

  copy(text: string) {
    window.navigator['clipboard'].writeText(text);
    this.usernameCopyText = "Copied";

  }
  stringToBase64(str) {
    let buffer = Buffer.from(str, 'utf8');
    return buffer.toString('base64');;
  }

  cancelContribution() {

    this.cancelProcessing = true;
    let guestEmailBase64 = this.stringToBase64(this.contirbution.guestEmail);

    this._paymentService.CancelContribution
      (JSON.stringify(
        {
          contributionId: this.contirbution.id,
          guestEmailBase64: guestEmailBase64,
          registryId: this.registry.id,
          cancelReason: this.cancelReason,
          cancelReasonOtherText: this.cancelReasonOtherText

        })
      ).subscribe(res => {
        this.cancelProcessing = false;
        this.manualSuccess = false;
        this.cancelCompleted = true;
        this.showCancelMode = false;
        this.manualPaymentProcessing = false;
        localStorage.removeItem('contrib');
        //this.router.navigate(['/' + this.registry.registryName.toLowerCase()]);

      });
  }
  setIhavePaid() {
    this.showTimeline = true;
  }
  completePayment() {

    this.processing = true;
    let guestEmailBase64 = this.stringToBase64(this.contirbution.guestEmail);
    this.manualPaymentProcessing = true;
    this._paymentService.SetAsIHavePaid
      (JSON.stringify(
        {
          contributionId: this.contirbution.id,
          guestEmailBase64: guestEmailBase64,
          registryId: this.registry.id,


        })
      ).subscribe(res => {
        this.showTimeline = false;
        this.cancelProcessing = false;
        this.showCancelMode = false;
        this.manualSuccess = true
        this.manualPaymentProcessing = false;
        localStorage.removeItem('contrib');
      });
  }




  expandTextArea(textArea: HTMLTextAreaElement) {
    textArea.rows = 2;
    const height = textArea.scrollHeight;
    textArea.rows = Math.floor(height / 16); // 20px = line-height: 1.25rem
  }

  createDefaultGifts() {

  }


  ngOnInit() {



    this.registry = this.route.snapshot.data.registry;
    this.isLoggedIn = this.route.snapshot.data.isLoggedIn;



    if (this.isLoggedIn) {
      this._registryFirebaseService.currentRegistry.subscribe(registry => {

        if (registry) {
          this.registry = registry;
        }
      });
    } else {
      // 
      let registryName = location.pathname
        .split('/')
        .filter(Boolean)
        .shift() || '';

      this._registryFirebaseService.registryByName(registryName).subscribe(registry => {
        this.registry = registry;
      });
    }



    if (this.registry && !this.registry.font) {
      this.registry.font = 'classic';
    }

    const urlParams = new URLSearchParams(window.location.search);
    this.contributionToken = null;
    this.contributionToken = urlParams.get('contributionToken');
    if (this.contributionToken) {
      this.showPopup = true;
      this.tokenVerifiying = true;


      this._paymentService.GetContriubtionFromToken(this.contributionToken).subscribe(res => {

        let body = res.json();

        localStorage.setItem('contrib', JSON.stringify(body.contribData));
        this.initPopupData(body.contribData);



        if (body.contribData.paymentStatus == 'paid') {
          this.manualSuccess = true;
          localStorage.removeItem('contrib');
        }


        let test = this.registry

        this.tokenVerifiying = false;

      });
    }


  }



  isBankTransfer(): boolean {
    return this.manualTransferMode && (
      this.manualTransferMode.startsWith('bank') ||
      this.manualTransferMode === 'bank2' ||
      this.manualTransferMode === 'bank3'
    );
  }

  close() {
    this.showPopup = false;

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.showCancelMode = false;
    this.manualSuccess = false;
    this.cancelProcessing = false;
    this.manualPaymentProcessing = false;

    this.cancelCompleted = false;
    // Parse the current URL properly
    const url = new URL(location.href);
    const basePathWithoutSuccess = url.pathname.toLowerCase().replace('/contribution-success', '');
    const urlPath = basePathWithoutSuccess + url.search; // Preserves query parameters
    // do a hard reload 
    window.location.href = `${window.location.origin}${urlPath}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/contribution-success-popup/contribution-success-popup.component.ts